// extracted by mini-css-extract-plugin
export default {"cls1":"VeloRadioTileGroup-Cell_cls1__zjDHB","cls2":"VeloRadioTileGroup-Cell_cls2__QNlos VeloRadioTileGroup-Cell_cls1__zjDHB"};